import TestimonialSection from './TestimonialSection'

export default TestimonialSection
